import { type ReactNode } from 'react';
import { X } from 'lucide-react';
import { pb } from '@/core/api';

export const MAX_MEDIA = 6;
export const HINT = 'Máx. 6 imágenes · 10MB · jpg, png, webp, gif';

function thumbUrl(id: string, file: string): string {
  const rec = { id, collectionId: 'comunicados' } as Parameters<
    typeof pb.files.getURL
  >[0];
  return pb.files.getURL(rec, file, { thumb: '400x0' });
}

const T_WRAP = 'relative overflow-hidden rounded-md border border-white/[0.06]';
const T_IMG = 'aspect-video w-full object-cover';
const T_X =
  'absolute right-1 top-1 rounded-full bg-black/70 p-1 text-white hover:bg-error';

function Thumb(p: {
  id: string;
  file: string;
  onRemove: () => void;
}): ReactNode {
  return (
    <div className={T_WRAP}>
      <img src={thumbUrl(p.id, p.file)} alt="" className={T_IMG} />
      <button
        type="button"
        onClick={p.onRemove}
        className={T_X}
        aria-label="Quitar"
      >
        <X size={12} />
      </button>
    </div>
  );
}

type GridProps = {
  id: string | undefined;
  files: string[];
  onRemove: (filename: string) => void;
};

export function MediaThumbGrid({ id, files, onRemove }: GridProps): ReactNode {
  if (!id || files.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-sm sm:grid-cols-3">
      {files.map((f) => (
        <Thumb key={f} id={id} file={f} onRemove={() => onRemove(f)} />
      ))}
    </div>
  );
}
